import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import StyledTooltip from "../../common/StyledTooltip";

export default function ComponentBreakdownCards({ principal, interest, processingFee }) {
  const data = [
    {
      title: principal?.componentName || "Principal",
      projected: principal?.projectedDisplay || "₹0",
      projectedOriginal: principal?.projected || 0,
      actual: principal?.actualDisplay || "₹0",
      actualOriginal: principal?.actual || 0,
      variance: principal?.varianceDisplay || "₹0",
      varianceOriginal: principal?.variance || 0,
      percent: `${principal?.pctVariance?.toFixed(1) || 0}%`,
      direction: principal?.direction || "DOWN",
    },
    {
      title: interest?.componentName || "Interest",
      projected: interest?.projectedDisplay || "₹0",
      projectedOriginal: interest?.projected || 0,
      actual: interest?.actualDisplay || "₹0",
      actualOriginal: interest?.actual || 0,
      variance: interest?.varianceDisplay || "₹0",
      varianceOriginal: interest?.variance || 0,
      percent: `${interest?.pctVariance?.toFixed(1) || 0}%`,
      direction: interest?.direction || "DOWN",
    },
    {
      title: processingFee?.componentName || "Processing Fee",
      projected: processingFee?.projectedDisplay || "₹0",
      projectedOriginal: processingFee?.projected || 0,
      actual: processingFee?.actualDisplay || "₹0",
      actualOriginal: processingFee?.actual || 0,
      variance: processingFee?.varianceDisplay || "₹0",
      varianceOriginal: processingFee?.variance || 0,
      percent: `${processingFee?.pctVariance?.toFixed(1) || 0}%`,
      direction: processingFee?.direction || "DOWN",
    },
  ];

  return (
    <div>
      <div
      
        style={{
          fontSize: "20px",
          fontWeight: "600",
          marginBottom: "16px",
        }}
      >
        Component-wise Breakdown
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3,1fr)",
          gap: "18px",
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              border: "0.8px solid #0000001A",

              borderRadius: "12px",

              padding: "18px 20px",

              background: "#ffffff",
            }}
          >
            <div
              style={{
                fontWeight: "600",
                marginBottom: "14px",
                fontSize: "16px",
              }}
            >
              {item.title}
            </div>

            <div style={row}>
              <span style={label}>Projected:</span>

              <span style={value}>
                <StyledTooltip value={item.projectedOriginal}>
                  {item.projected}
                </StyledTooltip>
              </span>
            </div>

            <div style={row}>
              <span style={label}>Actual:</span>

              <span
                style={{
                  ...value,
                  color: "#2563eb",
                  fontWeight: "600",
                }}
              >
                <StyledTooltip value={item.actualOriginal}>
                  {item.actual}
                </StyledTooltip>
              </span>
            </div>

            <div style={divider}></div>

            <div style={row}>
              <span style={label}>Variance:</span>

              <div style={{ textAlign: "right" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "6px",
                    color: item.direction === "UP" ? "#00A63E" : "#E84E4E",
                    fontWeight: "700",
                    whiteSpace: "nowrap",
                  }}
                >
                  <StyledTooltip value={item.varianceOriginal}>
                    {item.variance}
                  </StyledTooltip>

                  {item.direction === "UP" ? (
                    <TrendingUp size={15} width={"20px"} />
                  ) : (
                    <TrendingDown size={15} width={"20px"} />
                  )}
                </div>

                <div
                  style={{
                    color: item.direction === "UP" ? "#16a34a" : "#E84E4E",
                    fontSize: "13px",
                    marginTop: "2px",
                  }}
                >
                  {item.percent}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const row = {
  display: "flex",

  justifyContent: "space-between",

  alignItems: "center",

  marginBottom: "8px",
};

const label = {
  color: "#4A5565",
  marginBottom: "10px",
  fontSize: window.innerWidth >= 1800 ? '16px' : '14px',
  fontWeight: "400",
};

const value = {
  fontSize: window.innerWidth >= 1800 ? '18px' : '16px',

  color: "#0A0A0A",
  fontWeight: "500",
};

const divider = {
  height: "0.8px",

  background: "#0000001A",

  margin: "12px 0",
};
